import useLoad from 'components/hooks/useLoad';
import {sector} from 'constants/url';

function useLoadSectors() {
  return useLoad(sector, 'iD_Sector', {});
}

export default useLoadSectors;
